import React, { FC, useMemo, useState } from 'react';
import styles from './index.module.scss';
import { ListBox, ReadOnlyText, ReadOnlyDate, BoxActions } from 'src/shared';
import { Translations } from 'src/lib/I18nService/types';
import { ITenderBox, isFieldDate, isFieldString, TenderBlockSize } from 'src/models/procurements/Tender/types';
import { TenderBoxFieldType } from '@tendium/prom-types/tender';
import { useTranslation } from 'react-i18next';

export interface IProps {
  box: ITenderBox;
  index: number;
  expandable?: boolean;
  isExpanded?: boolean;
  size?: TenderBlockSize;
}

export const QAndABox: FC<IProps> = ({ box, index, expandable, isExpanded }) => {
  const { fields } = box;
  const { t: tenderT } = useTranslation(Translations.procurements);
  const [isHovered, setIsHovered] = useState(false);

  const idField = useMemo(() => {
    const fieldString = fields && fields.find(field => field.name === 'ID');
    return isFieldString(fieldString) ? fieldString : undefined;
  }, [fields]);
  const date = useMemo(() => {
    const fieldDate = fields && fields.find(field => field.type === TenderBoxFieldType.Date);
    return isFieldDate(fieldDate) ? fieldDate.date : undefined;
  }, [fields]);
  const title = useMemo(() => {
    const fieldString = fields && fields.find(field => field.name === 'Question');
    return isFieldString(fieldString) ? fieldString.string : undefined;
  }, [fields]);
  const content = useMemo(() => {
    const fieldString = fields && fields.find(field => field.name === 'Answer' || field.name === 'Addition');
    return isFieldString(fieldString) ? fieldString.string : undefined;
  }, [fields]);

  return (
    <ListBox
      title={title ? title : undefined}
      value={
        <>
          {content && <ReadOnlyText string={content} />}

          <div className={styles.meta}>
            {date && idField ? (
              <>
                <span className={styles.metaItem}>
                  <ReadOnlyDate date={date} />
                </span>
                <span className={styles.metaItem}>{`${tenderT(idField.name)}: ${idField.string}`}</span>
              </>
            ) : null}
            {!title && <BoxActions box={box} isActive={isHovered} className={styles.actions} />}
          </div>
        </>
      }
      index={index}
      expandable={expandable}
      size={TenderBlockSize.ThreeQuarters}
      isExpanded={isExpanded}
      actions={<BoxActions box={box} isActive={isHovered} className={styles.actions} />}
      setIsHovered={setIsHovered}
    />
  );
};

export default QAndABox;
